import { render, staticRenderFns } from "./_betList.vue?vue&type=template&id=85811a1e&lang=pug&"
import script from "./_betList.vue?vue&type=script&lang=js&"
export * from "./_betList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports